import { doc, getDoc, getDocs, Timestamp } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { fetchEvent } from '../utils/firebase';
import { REGISTER_EVENT_PATH } from '../App';
import { formatFirestoreTimestamp } from '../utils/common';
import { fighterEntryDisplayMapping } from '../constants';

export default function EventRegisterCard({ eventRegister }) {
    const navigate = useNavigate();
    const [event, setEvent] = useState(null)
    useEffect(() => {
        (async () => {
            const eventId = eventRegister?.eventId ?? eventRegister?.data?.eventId ?? null;
            if (!!eventId) {

                const fetchedEvent = await fetchEvent({
                    id: eventId
                });

                if (!!fetchedEvent.data) {
                    setEvent({
                        ...fetchedEvent.data,
                        dateTime: !fetchedEvent.data.dateTime?._seconds ? null : Timestamp.fromMillis(fetchedEvent.data.dateTime?._seconds * 1000),
                        registerExpiredDateTime: !fetchedEvent.data.registerExpiredDateTime?._seconds ? null : Timestamp.fromMillis(fetchedEvent.data.registerExpiredDateTime?._seconds * 1000),
                        createdAt: !fetchedEvent.data.createdAt?._seconds ? null : Timestamp.fromMillis(fetchedEvent.data.createdAt?._seconds * 1000),
                        updateAt: !fetchedEvent.data.updateAt?._seconds ? null : Timestamp.fromMillis(fetchedEvent.data.updateAt?._seconds * 1000)
                    })
                } else {
                    navigate("/404");
                }
            }
        })()
    }, [eventRegister?.data?.eventId, eventRegister?.eventId])


    // uid, eventId, email, type, status, data, createdAt, updateAt

    // fighterId, eventId, entry, receipt

    // color,  

    if (!event) {
        return <div className='flex-center p-0 md:p-4 border w-full'>
            <div className='loading loading-md loading-bars' />
        </div>
    }
    return (
        <Link className='flex flex-row items-stretch w-full gap-4 hover:bg-base-200 p-0 md:p-4' to={`${REGISTER_EVENT_PATH}/${event.id}`}>
            <div className='border aspect-[3/4] w-full max-w-[16rem] relative'>
                <img className='w-full h-full object-cover object-center abs-center opacity-50 blur-sm z-[1]' src={event.coverImage} alt="Event Cover" />
                <img className=' p-2 w-full h-full object-contain object-center abs-center aspect-[3/4] z-[2]' src={event.coverImage} alt="" />
            </div>
            <div className="flex flex-col w-full p-0 gap-2">
                <p className='font-bold text-2xl'>{event.name}</p>
                <p>Status: <span className='badge badge-outline'>{eventRegister.status}</span></p>
                <p>Entry: {fighterEntryDisplayMapping[eventRegister.data.entry] ?? "???"}</p>
                <p>Register on: {formatFirestoreTimestamp(eventRegister.updateAt)}</p>
                <p>Venue: {event.venue?.trim() || "???"}</p>
                <p>Address {event.address?.trim() || "???"}</p>
                {/* <div className="flex flex-row justify-end gap-2 w-full" onClick={(e) => { e.stopPropagation(); }}>
                    <div className="flex flex-row justify-end items-center">
                        <a target='_blank' href={event?.googleMap} className='btn btn-ghost btn-square p-2' rel="noreferrer">
                            <img className='w-full h-full' src="/assets/img/logo-googlemaps.svg" alt="waze" />
                        </a>
                    </div>
                    <div className="flex flex-row justify-end items-center">
                        <a target='_blank' href={event?.waze} className='btn btn-ghost btn-square p-2' rel="noreferrer">
                            <img className='w-full h-full' src="/assets/img/logo-waze.svg" alt="waze" />
                        </a>
                    </div>
                </div> */}
            </div>
        </Link>
    )
}
